import { renderToString } from "react-dom/server";
import { Text } from "domhandler";

import parse, { DOMNode } from "html-react-parser";
import { ProductType } from "../types";

const ELEMENT_REGEX = /({{.*?}})/gs;
const STATIC_REGEX = /(\[\[.*?\]\])/gs;

export function parsedHtmlTransformation(html: string, data: Record<string, any> = {}) {
    let staticMatches = html.match(STATIC_REGEX);

    if (staticMatches && (staticMatches?.length || 0) > 0) {
        for (const match of staticMatches) {
            const key = match
                .replace("[[", "")
                .replace("]]", "")
                .toLowerCase()
                .replace(" ", "")
                .trim();

            const stringToInsert = renderToString(data[key]);

            const regex = new RegExp("(\\[\\[" + key + "\\]\\])", "gs");
            html = html.replace(regex, stringToInsert);
        }
    }

    // find all in data that is undefined
    const toRemove = html.match(ELEMENT_REGEX)?.filter(match => {
        const key = match.replace("{{", "").replace("}}", "").toLowerCase().replace(" ", "").trim();
        return data[key] === undefined;
    });

    const options = {
        replace: (domNode: DOMNode) => {
            if (domNode.type === "text") {
                const text = domNode as Text;
                const value = text.data.trim();

                if ((value.match(ELEMENT_REGEX)?.length || 0) > 0) {
                    const key = value
                        .replace("{{", "")
                        .replace("}}", "")
                        .toLowerCase()
                        .replace(" ", "")
                        .trim();
                    const newValue = data[key];
                    return newValue;
                }
            }

            return "";
        }
    };

    toRemove?.forEach(match => {
        html = html.replace(match, "");
    });

    return parse(html, options) as JSX.Element;
}

export function constructProductMetricHtml(
    productPricingMetrics: ProductType["productPricingMetrics"],
    selectedProduct: ProductType
) {
    let resultHtml = "";
    try {
        resultHtml = (productPricingMetrics ?? [])
            ?.map(ppm => {
                let clcHtml = ppm.calculationHtml;
                for (const [key, value] of Object.entries(selectedProduct)) {
                    let hasKey = clcHtml.includes(key);
                    if (hasKey) {
                        clcHtml = clcHtml.replace(new RegExp(key, "g"), value);
                    }
                }
                clcHtml = clcHtml
                    .split("$")
                    .map(el => {
                        let firstBraceIdx = el.indexOf("{");
                        let lastBraceIdx = el.indexOf("}");
                        if (firstBraceIdx >= 0 && lastBraceIdx >= 0) {
                            let evalExpress = el.substring(firstBraceIdx + 1, lastBraceIdx);
                            let computedVal = eval(evalExpress);
                            el = el.replace(evalExpress, computedVal);
                            return el;
                        }
                        return el;
                    })
                    .join("");
                clcHtml = clcHtml.replace(new RegExp("{", "g"), "");
                clcHtml = clcHtml.replace(new RegExp("}", "g"), "");
                return clcHtml;
            })
            .join("/n");
        return resultHtml;
    } catch (error) {
        return resultHtml;
    }
}
